// extracted by mini-css-extract-plugin
module.exports = {"users":"ThankYou_users__78tiB","user":"ThankYou_user__12ZyC","profilePlaceholder":"ThankYou_profilePlaceholder__hTZJC","verified":"ThankYou_verified__1_Adn"};